'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _actions = require('../../utils/actions');

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var render = function render(_ref) {
	var props = _ref.props;
	var hideLabel = props.hideLabel,
	    id = props.id,
	    iconClosed = props.iconClosed,
	    iconClosedSize = props.iconClosedSize,
	    iconClosedColor = props.iconClosedColor,
	    iconOpen = props.iconOpen,
	    iconOpenSize = props.iconOpenSize,
	    iconOpenColor = props.iconOpenColor,
	    isOpen = props.isOpen,
	    label = props.label,
	    styleClasses = props.styleClasses,
	    toggle = props.toggle;

	var children = props.children.length > 0 ? props.children : (0, _magicVirtualElement2.default)('div', { 'data-id': id, 'class': 'CMS-Dropdown-placeholder CMS-Component' });
	var openIcon = (0, _actions.getIcon)({ icon: iconOpen, iconColor: iconClosedColor, iconSize: iconOpenSize, label: label });
	var closedIcon = (0, _actions.getIcon)({ icon: iconClosed, iconColor: iconOpenColor, iconSize: iconClosedSize, label: label });

	var classes = {
		'is-open': isOpen
	};

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CMS-Toggler-wrapper', classes, styleClasses.Wrapper], 'data-style-attr': 'Wrapper' },
		(0, _magicVirtualElement2.default)(
			'div',
			{ 'class': ['CMS-Toggler', props.class, styleClasses.TogglerHeading], 'data-style-attr': 'TogglerHeading', onClick: toggle },
			(0, _magicVirtualElement2.default)(
				'span',
				{ 'class': ['CMS-Toggler-label', styleClasses.Label], 'data-style-attr': 'Label' },
				!hideLabel && label
			),
			(0, _magicVirtualElement2.default)(
				'span',
				{ 'class': ['CMS-Toggler-icon', styleClasses.Icon], 'data-style-attr': 'Icon' },
				isOpen ? openIcon : closedIcon
			)
		),
		(0, _magicVirtualElement2.default)(
			'div',
			{ 'class': ['CMS-Toggler-body', classes, styleClasses.Body], 'data-style-attr': 'Body' },
			children
		)
	), props);
}; /** @jsx dom */
exports.default = { render: render };